export default "__VITE_ASSET__Cj_J6g0a__"